<div class="about-section">
  <div class="top-img-container">
    <img
      src="./assets/images/ngcommSite.png"
      alt="Photo of the community at ng-conf"
    />
  </div>
  <div class="top-text">
    <h1>{{ 'landingTitle' | transloco }}</h1>
    <h4 class="lineheight">
      {{ 'landingParagraph' | transloco }}
      <br />
      <div class="line-break">
        {{ 'meetingsSchedule' | transloco }}
      </div>
    </h4>
    <div class="social-button-container">
      <a
        class="meetupbutton"
        mat-stroked-button
        href="https://www.meetup.com/angularcommunity/"
        target="_blank"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/Meetup_Logo.png"
          class="follow-btn-image"
          alt="Meetup logo"
        />
        {{ 'joinMeetup' | transloco }}
      </a>
      <a
        mat-raised-button
        class="twitterbutton"
        href="https://twitter.com/angular_meetup"
        target="_blank"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true" class="twitter-btn-image">
          <g>
            <path
              d="M23.643 4.937c-.835.37-1.732.62-2.675.733.962-.576 1.7-1.49 2.048-2.578-.9.534-1.897.922-2.958 1.13-.85-.904-2.06-1.47-3.4-1.47-2.572 0-4.658 2.086-4.658 4.66 0 .364.042.718.12 1.06-3.873-.195-7.304-2.05-9.602-4.868-.4.69-.63 1.49-.63 2.342 0 1.616.823 3.043 2.072 3.878-.764-.025-1.482-.234-2.11-.583v.06c0 2.257 1.605 4.14 3.737 4.568-.392.106-.803.162-1.227.162-.3 0-.593-.028-.877-.082.593 1.85 2.313 3.198 4.352 3.234-1.595 1.25-3.604 1.995-5.786 1.995-.376 0-.747-.022-1.112-.065 2.062 1.323 4.51 2.093 7.14 2.093 8.57 0 13.255-7.098 13.255-13.254 0-.2-.005-.402-.014-.602.91-.658 1.7-1.477 2.323-2.41z"
              fill="#d9d9d9"
            ></path>
          </g>
        </svg>
        {{ 'followTwitter' | transloco }}
      </a>
    </div>
  </div>
</div>

<div class="gray-section">
  <div>
    <h5>{{ 'callForProposalTitle' | transloco }}</h5>
  </div>
  <div>
    <p>{{ 'callForProposalText' | transloco }}</p>
  </div>
  <div class="button">
    <a
      class="button-row"
      mat-raised-button
      color="primary"
      [href]="cfpByLanguage"
      target="_blank"
    >
      {{ 'submitProposalBtn' | transloco }}
    </a>
  </div>
</div>

<div class="team-section">
  <div>
    <h5>{{ 'theTeamTitle' | transloco }}</h5>
  </div>
  <div class="row">
    <angular-community-profile-card
      class="col"
      name="Brooke Avery"
      position="Founder"
      twitterHandle="JediBravery"
      linkedinHandle="jedibravery"
      img="./assets/images/brookesidepic.png"
      bio="{{ 'bioBrooke' | transloco }}"
    >
    </angular-community-profile-card>
  </div>
  <h2>{{ 'director' | transloco }}</h2>
  <div class="row">
    <angular-community-profile-card
      class="col"
      name="Chris Perko"
      twitterHandle="chrisjperko"
      linkedinHandle="chris-perko"
      websiteLink="https://perko.dev"
      bio="{{ 'bioPerko' | transloco }}"
      img="./assets/images/perko_headshot.jpg"
      position="Director of Technology"
    ></angular-community-profile-card>

    <angular-community-profile-card
      class="col"
      name="Giovanni Rivas"
      position="Director of Communications"
      twitterHandle="garf50"
      linkedinHandle="giovanni-rivas-flores"
      img="./assets/images/giovanni_headshot.png"
      bio="{{ 'bioGiovanni' | transloco }}"
    ></angular-community-profile-card>
  </div>

  <h2>{{ 'coOrganizers' | transloco }}</h2>

  <div class="row">

    <angular-community-profile-card
      class="col"
      name="McKenna Todd"
      linkedinHandle="mckenna-todd"
      bio="{{ 'bioMckenna' | transloco }}"
      img="./assets/images/McKennaTodd-Headshots.JPG"
    >
    </angular-community-profile-card>

    <angular-community-profile-card
      class="col"
      name="Alejandro Cuba Ruiz"
      linkedinHandle="alejandrocuba"
      twitterHandle="zorphdark"
      bio="{{ 'bioAlejandro' | transloco }}"
      img="./assets/images/alejandro_headshot.png"
    >
    </angular-community-profile-card>

    <angular-community-profile-card
      class="col"
      name="Eduardo Roth"
      linkedinHandle="eduardoroth"
      twitterHandle="eduardoRoth"
      bio="{{ 'bioEduardo' | transloco }}"
      img="./assets/images/eduardo_headshot.png"
    >
    </angular-community-profile-card>
  </div>

  <div class="row">
    <angular-community-profile-card
      class="col"
      name="Markus Ingvarsson"
      linkedinHandle="markusingvarsson"
      twitterHandle="markusingvarssn"
      websiteLink="http://markusingvarsson.com/"
      bio="{{ 'bioMarkus' | transloco }}"
      img="./assets/images/markus_headshot.jpeg"
    >
    </angular-community-profile-card>

    <angular-community-profile-card
      class="col"
      name="Matt Verry"
      linkedinHandle="mattvdev"
      twitterHandle="mattv_dev"
      websiteLink="https://mattv.info/about"
      bio="{{ 'bioMatt' | transloco}}"
      img="./assets/images/matt_headshot.jpg"></angular-community-profile-card>

    <angular-community-profile-card
      class="col"
      name="Alfredo Perez"
      twitterHandle="alfrodo_perez"
      linkedinHandle="alfredo-perez"
      img="./assets/images/alfredo_headshot.png"
      bio="{{ 'bioAlfredo' | transloco }}"
    ></angular-community-profile-card>
  </div>

    <div class="row">
        <angular-community-profile-card
                class="col"
                name="Preston Lamb"
                twitterHandle="prestonjlamb"
                linkedinHandle="pjlamb12"
                bio="{{ 'bioPreston' | transloco }}"
                img="./assets/images/preston_headshot.png"
        >
        </angular-community-profile-card>

      <angular-community-profile-card
        class="col"
        name="Kensy Alaya"
        twitterHandle="kjosaayala"
        linkedinHandle="kensy-ayala"
        websiteLink="https://kjosa-ayala.com/"
        bio="{{ 'bioKensy' | transloco }}"
        img="./assets/images/kensy-headshot.jpeg"></angular-community-profile-card>

        <angular-community-profile-card
            class="col"
            name="Rafael Mestre"
            twitterHandle="mestre_dev"
            linkedinHandle="rlmestre"
            bio="{{'bioRafael' | transloco }}"
            img="./assets/images/rafa-headshot.jpg"
        ></angular-community-profile-card>
    </div>

  <div class="row">
    <angular-community-profile-card
      class="col"
      name="Matthew Christiansen"
      linkedinHandle="matthewbchristiansen"
      websiteLink="https://sessionize.com/matticus/"
      img="./assets/images/matthew-c-headshot.png"
      bio="{{'bioMatthewC' | transloco}}"></angular-community-profile-card>
  </div>
</div>
